import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/fonts.ts';
import './styles/globals.css';
import { App } from './App.tsx';
import { installChunkReloadHandler } from './lib/chunk-reload.ts';

// Hash-mismatch recovery — must run before any lazy import is resolved so it
// can intercept "Failed to fetch dynamically imported module" rejections
// caused by stale HTML referencing deleted asset hashes after a redeploy.
installChunkReloadHandler();

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
